import { Button } from "@mui/material";
import { useSelector } from "react-redux";

export default function CustomButton({ buttonText, onClick, id, width, disabled, sx: customSx, ...rest }) {
    const theme = useSelector(state => state.themedata.theme);
    const defaultSx = {
        border: '0px solid',
        height: '35px',
        minWidth: '70px',
        width: width ? width : 'auto',
        maxWidth: "500px",
        padding: '8px 16px',
        color: disabled === true ? '#7E7E7E' : '#FFFFFF',
                fontWeight: 700,
        backgroundColor: (disabled === true ? theme === 'light' ? '#C1C1C1' : '#3C3C3C' : '#005C8E'),
        '&:hover': {
            backgroundColor: 'none',
            border: '2px solid',
            borderColor: theme === 'light' ? '#005C8E' : '#FFFFFF',
            color: theme === 'light' ? '#005C8E' : '#FFFFFF',
            fontWeight: 700,
        },
        "&:disabled": {
            fontWeight: 400,
            color: '#7E7E7E',
        }
            };
    return (
        <Button
            disabled={disabled ? disabled : false}
            style={{
                borderRadius: '20px',
                fontSize: '16px',
                textTransform: 'none',
                fontFamily: 'Roboto',
                cursor: 'pointer',
            }}
            sx={{ ...defaultSx, ...customSx }}
            id={id != null ? id : null}
            onClick={onClick}
            {...rest}
        >
            {buttonText}
        </Button>
    )
}